import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

export default function NotFound({ testId = "page-not-found", title = "Hmm, we couldn't find that page." }) {
  useSeo({ title: "Page not found", description: "Sorry, this page doesn't exist or has moved. Browse ShopaBee's latest new, open-box and pre-loved finds instead.", noindex: true });
  return (
    <section className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid={testId}>
      <p className="font-display text-6xl font-bold text-[#FFD23F]" aria-hidden="true">404</p>
      <h1 className="mt-2 font-display text-3xl font-bold">{title}</h1>
      <p className="mt-2 text-sm text-[#202A35]/70">It may have sold, moved or never existed. Here are some good places to start:</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link to="/" className="h-11 leading-[44px] px-6 rounded-full bg-[#202A35] text-white text-sm font-bold" data-testid="not-found-home-link">Back to home</Link>
        <Link to="/shop" className="h-11 leading-[40px] px-6 rounded-full border-2 border-[#202A35] text-sm font-bold" data-testid="back-to-shop-link">Browse the shop</Link>
      </div>
    </section>
  );
}
